var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",class:_vm.color},[_c('div',{staticClass:"circle bounce1"}),_c('div',{staticClass:"circle bounce2"}),_c('div',{staticClass:"circle bounce3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }